import { HttpClient } from "@angular/common/http";
import { HttpControllers } from "./HttpControllers";
import { HttpControllerArgFetch } from "../../interfaces/http-controller.interface";
import { ApiResponse } from "../../interfaces/response.interface";
import { Observable } from "rxjs";
import { PartialNestedObject } from "../../interfaces/common.interface";
import { QueryParams } from "../../interfaces/request.interface";

/* The line `export abstract class AbstractHttpController<K> extends HttpControllers<K>` is defining an
abstract class called `AbstractHttpController` that extends another class called `HttpControllers`.
The class is generic, with the generic type `K` being used throughout the class definition. */
export abstract class AbstractHttpController<K> extends HttpControllers<K> {
  protected abstract _endpoint: string
  protected abstract _queryParams: QueryParams<K>

  constructor(
    private readonly httpClient: HttpClient
  ) {
    super(httpClient);
  }

  public abstract get queryParams(): QueryParams<K>
  public abstract set queryParams(queryParams: QueryParams<K>)

/* These are abstract methods that define the contract for implementing classes. */
  public abstract find(args?: PartialNestedObject<K>): Observable<ApiResponse<K[]>>;
  public abstract findOne(args?: PartialNestedObject<K>): Observable<ApiResponse<K>>
  public abstract findBy(args?: PartialNestedObject<K>,): Observable<ApiResponse<K[]>>
  public abstract remove(args?: PartialNestedObject<K>,): Observable<ApiResponse<K>>
  public abstract make(args?: PartialNestedObject<K>,): Observable<ApiResponse<K>>
}
